import { Grid } from "@mui/material";

import TransparentFragment from "../../../../helper-components/misc/TransparentFragment";

export default function GetReadyLowerJaw() {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <TransparentFragment title={`Get ready to chart lower jaw`} center p={8} />
            </Grid>
        </Grid>
    );
}
